<template>
	<div class="xingxi_set">
		<header>
			<h1>
				<router-link to="/mine">
					<v-icon name="chevron-left" class="set_2"></v-icon>
				</router-link>
				<p class="set_1">修改资料</p>
			</h1>
		</header>
		<div class="set_get">
		<ul>
			<li class="name_save">
				姓名
				<input type="text" name="name" placeholder="请输入您的姓名*" id="namea">
			</li>
			<li class="sex_li">
				性别
				<select id="data_sex">
					<option value="男">男</option>
 					<option value="女">女</option>
				</select>
			</li>
			<li class="data_li">
				生日
				<input type="date" name="date" id="data_basd" value="1970-01-01">
			</li>
			<li class="phone_save">
				手机
				<input type="number" name="" placeholder="请输入您的手机*" id="phone">
			</li>
			<li class="addres_save">
				地址
				<input type="" name="" placeholder="请输入您的地址*" id="addres">
			</li>
		</ul>
		<button class="set_butsave" id="savebut" v-on:click="add()">保存</button>
		</div>
		<div class="tc_nav">
			<span class="tc_navx"></span>
		</div>
	</div>
</template>
<script>
import $ from 'jquery';
import { CURL } from "../../lib/url.js";
export default {
data() {
	return {
		xingxi:[],
	}
},
mounted(){
	this.getAjax()
},
methods:{
	add:function(){
		var name= $('#namea').val();
		var phone= $('#phone').val();
		var addres= $('#addres').val();
		var data_sex= $('#data_sex').val();
		var data_basd= $('#data_basd').val();
		var openid=localStorage.getItem("openid");
		//console.log(name+'     '+phone+'    '+addres+'    '+data_sex+'   '+data_basd)
		this.xingxi = {name,phone,addres,data_sex,data_basd}
		console.log(this.xingxi)
		if(name == '' || name == null){
			$('.tc_navx').text('请填写个人姓名')
			$('.tc_nav').fadeIn()
			setTimeout(function(){
				$('.tc_nav').fadeOut()
			},2000)
		}else if(phone == '' || phone == null){
			$('.tc_navx').text('请填写手机号码')
			$('.tc_nav').fadeIn()
			setTimeout(function(){
				$('.tc_nav').fadeOut()
			},2000)
		}else if(addres == '' || addres == null){
			$('.tc_navx').text('请填写具体地址')
			$('.tc_nav').fadeIn()
			setTimeout(function(){
				$('.tc_nav').fadeOut()
			},2000)
		}else if(data_basd == '' || data_basd == null){
			$('.tc_navx').text('请填写出生日期')
			$('.tc_nav').fadeIn()
			setTimeout(function(){
				$('.tc_nav').fadeOut()
			},2000)
		}else{
		var successCallback =  (response) => {
	      console.log('success')
	      if(response.num == 1){
	      	$('.tc_navx').text('修改成功')
			$('.tc_nav').fadeIn()
			setTimeout(function(){
				$('.tc_nav').fadeOut()
			},2000)
	      }else if(response.num == 0){
	      	$('.tc_navx').text('修改失败')
			$('.tc_nav').fadeIn()
			setTimeout(function(){
				$('.tc_nav').fadeOut()
			},2000)
	      }
	    }
	    var errorCallback =  (response) => {
	        console.log('error')
	    }
	    this.$http.get(CURL+'/portal/All/geteditusers?name='+name+'&phone='+phone+
	    	'&addres='+addres+'&data_sex='+data_sex+'&data_basd='+data_basd+'&openid='+openid).then(successCallback,errorCallback);
		}
    },
  	getAjax:function () {
  	var openid=localStorage.getItem("openid");
   	var successCallback =  (response) => {
      console.log('success')
      $('#namea').val(response.data.name)
      $('#phone').val(response.data.phone)
      $('#data_basd').val(response.data.birthday)
      if(response.data.sex == 1){
      	$('#data_sex').val('男')
      }else{
      	$('#data_sex').val('女')
      }
      $('#addres').val(response.data.address)
    }
    var errorCallback =  (response) => {
        console.log('error')
    }
    this.$http.get(CURL+'/portal/All/geteduser?openid='+openid).then(successCallback,errorCallback);
  	}
}
}
</script>
<style lang="scss" scoped>
/**/
.tc_navx{
	background-color: #00a8d9;
	border-radius: 5px;
	padding: 10px 20px 10px 20px;
}
.tc_nav{
	display: none;
	position: fixed;
	margin-left: 20%;
	text-align: center;
	width: 60%;
/*	height: 30px;*/
	color: #ffffff;
	font-size: 15px;
	bottom: 70%;
}
/*cont*/
.data_li{
	line-height: 40px;
}
.sex_li{
	line-height: 40px;
}
#data_sex{
	width: 20%;
	margin-left: 70%;
}
#data_basd{
	width: 35%;
	margin-left: 55%;
	height: 20px;
}
ul{
	background-color: #FFFFFF;
	li{
		border-bottom: #eee solid 2px;
		height: 40px;
		padding-left: 10px;
	}
}
input{
	width: 90%;
	text-align: right;
	padding-right: 5%;
}
input::placeholder{
	text-align: right;
}
.set_butsave{
	width: 80%;
	margin: 80px 10% 0 10%;
	height: 40px;
	line-height: 40px;
	border-radius: 5px;
	color: #FFFFFF;
	background:url(../../img/ss.png);
  	background-size: cover 100% 100%;
  	background-repeat: no-repeat;
	font-weight: 600;
	font-size: 15px;
}
.set_get{
	float: left;
	width: 100%;
	padding-top: .45rem;
}
/*head*/
header{
	position: fixed;
  	height: .4rem;
 	background:url(../../img/ss.png);
  	background-size:100% 100%;
  	background-repeat: no-repeat;
 	float: left;
 	width: 100%;
}
.set_1{
	text-align: center;
    float: left;
    width: 80%;
    line-height: .4rem;
    font-weight: 600;
    color: #FFFFFF;
    font-size: 19px;
}
.set_2{
	float: left;
	margin-left: 3%;
	margin-top: 12px;
	width: 5%;
	color: #FFFFFF;
}
/*xxxx*/
.xingxi_set{
	width: 100%;
	height: 100%;
	float: left;
}
</style>


// WEBPACK FOOTER //
// src/components/mine/xingxi.vue